export const uniqueArray = arr => [...new Set(arr)];
